export default __webpack_public_path__ + "static/media/fida.17360818.svg";